<template>
  <div class="header_wrap">
    <div class="header">
      <span class="fl">欢迎访问黄冈师范学院体育场馆中心网站！</span>
      <span class="corner fr">
					<ul>
						<!--<li><a href="register.html">注册</a>|</li>
						<li class="login_li"><a href="javascript:void(0);" class="tc">登录</a></li>-->
            <li>{{dateStr}}</li>
					</ul>
					<div class="clear"></div>
				</span>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
  import {parseTime} from 'src/utils/myUtils'

  export default {
    data () {
      return {
        dateStr: ''
      }
    },
    components: {},
    mounted () {
      this.$nextTick(function () {
        this.onLoadDate()
      })
    },
    methods: {
      onLoadDate () {
        let that = this
        window.setInterval(function () {
          that.dateStr = parseTime(new Date())
        }, 1000)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/TopHeader.vue